import React from 'react'
import {Box} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import {renderLayoutsSwitch} from '../../utils/contentRenderer'

const ContainerPage = ({content}) => {
    return (
        <Box>
            {content?.MainRegion?.map((contentRegion, contentIndex) => {
                const currentContent = contentRegion.ContentLink.Expanded
                return (
                    <React.Fragment key={contentIndex}>
                        {renderLayoutsSwitch(currentContent, {...content})}
                    </React.Fragment>
                )
            })}
        </Box>
    )
}

ContainerPage.displayName = 'ContainerPage'

ContainerPage.propTypes = {
    content: PropTypes.object
}

export default ContainerPage
